import { useMediaQuery } from '@mui/material';

/**
 * Device size hook.
 *
 * @author Mikhail Siutsou
 * @function useDeviceSize
 * @category helper
 * @return {{ mobile: boolean; tablet: boolean; desktop: boolean; }} return device sizes.
 */
export var useDeviceSize = function useDeviceSize() {
  return {
    mobile: useMediaQuery(function (theme) {
      return theme.breakpoints.down('tablet');
    }),
    tablet: useMediaQuery(function (theme) {
      return theme.breakpoints.between('tablet', 'desktop');
    }),
    desktop: useMediaQuery(function (theme) {
      return theme.breakpoints.up('desktop');
    })
  };
};